<template>
  <div class="page-contacts-request-cta">
    <!-- Appuntamento Showroom -->
    <div class="m-top-6">
      <h2 class="text-xl">{{ $t('pages.contacts.physical-appointment') }}</h2>
      <!-- <NuxtLink
        :to="
          localePath({
            name: 'contacts-requests',
            query: {
              type: 'showroom',
            },
          })
        "
        class="button-round-1 --dark m-top-16px"
      >-->
      <NuxtLink
        :to="
          localePath({
            name: 'contacts-requests',
          })
        "
        class="button-round-1 --dark m-top-16px"
      >
        <span>{{ $t('cta.requestPhysicalAppointment') }}</span></NuxtLink
      >
    </div>

    <!-- Appuntamento Digitale -->
    <div class="m-top-6">
      <h2 class="text-xl">{{ $t('pages.contacts.digital-appointment') }}</h2>
      <!-- <NuxtLink
        :to="
          localePath({
            name: 'contacts-requests',
            query: {
              type: 'virtual',
            },
          })
        "
        class="button-round-1 --dark m-top-16px"
      > -->
      <NuxtLink
        :to="
          localePath({
            name: 'contacts-requests',
          })
        "
        class="button-round-1 --dark m-top-16px"
      >
        <span>{{ $t('cta.requestDigitalAppointment') }}</span></NuxtLink
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesContactsRequestCta',
}
</script>

<script setup></script>

<style lang="scss">
@import './style.scss';
</style>
